/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useEffect, useState, useCallback, useRef } from "react";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
import Skeleton from "./skeleton";
import { CAR_LIST_EVENT_NAMES, COUNTRY, ORDER_TYPE, FEATURE_FLAG_KEYS, NUMBER, REFERRER_SOURCE, ENABLE_MINIMUM_SPLIT_PAY, SET_DELIVERY_TIMELINE, DELIVERY_TIMELINE_MAPPING, LOAN_PROVIDER, PAGE_SOURCE, WEB_SOURCE} from "../../../constants/app-constants";
import { getCheckoutPageURL, getMyBookingCarDetailsURL } from "../../../utils/helpers/get-detail-page-url";
import { checkoutRoutes } from "../../../constants/au.desktop/checkout-routes";
import { InView, useInView } from "react-intersection-observer";
// import { ORDER_STATUS } from "../../../constants/checkout-constants";
import styles from "./styles.css";
import { trackCustomReMarketingEvents, trackDesktopCustomEventsAU, desktopCleverTapEvent, showSiteControlWidget } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import MetaTagsCarDetailsV2 from "../../shared/meta-tags-car-details-v2";
import carListingEventDataParser from "../../../tracking/parser/car-listing";
import KelleyBlueBookPopup from "../kelley-blue-book-popup/component";
import { tasksRoutes } from "../../../constants/au.desktop/tasks-routes";
import PageNotFoundRevamp from "../page-not-found-revamp";
import showFeature from "../../../utils/helpers/show-feaure";
import CarReservationNotifyModal from "../car-reservation-notify-modal";
import { postOrderBookingConfirmed } from "../../../utils/helpers/post-order-placed-confirmed";
import { useLocation } from "react-router-dom";
import qs from "query-string";
// import CarDetailsFaq from "../../shared/car-details-faq";
const CarDetailsFaq = loadable(() => import("../../shared/car-details-faq"), { fallback: <Skeleton /> });
import { showCdpBiCtaVariant} from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { CHECKOUT_STEPS, CHECKOUT_STEPS_PATH, FINANCE_TYPE, LOGIN_TYPE, NOT_LOGGED_IN, ORDER_STATUS, VERIFY_LICENCE_STATES } from "../../../constants/checkout-constants";
import TrackImpression from "../../shared/track-impression";
import saveCookie from "../../../utils/helpers/save-cookie";
import { MARKETING_EVENTS_CONSTANTS } from "../../../tracking/marketing-page-events";
import carListingEventDataParserGA4, { parseFilterToDimensionGA4 } from "../../../tracking/parser/car-listing-ga4";
import { clearItem } from "../../../utils/helpers/storage-crud";
// import CoachMark from "../coach-mark/component";
import parseCookie from "../../../utils/helpers/parse-cookie";
import CDPBreadCrumb from "../cdp-breadcrumb";
import ErrorHandler from "../../shared/with-error-handler";
import { postPaymentRoutes } from "../../../constants/au.desktop/post-payment-routes";
import { FB_EVENTS_CATEGORY } from "../../../tracking/fb-events";
import { AMPLITUDE_EVENTS_CATEGORY, CDP_REVAMP_AMPLITUDE_EVENTS } from "../../../tracking/amplitude-events";
import clevertapDetails from "../../../tracking/parser/clevertap-details";
import { CLEVERTAP_EVENT_MAP } from "../../../tracking/au.desktop-clevertap";
import { addToRecentlyViewed } from "../../../utils/helpers/recently-viewed";
import { AU_RECENTLY_VIEWD_KEY } from "../../../constants/app-constants";
// import { modelYearNameGenerator } from "../../../utils/helpers/model-year-name-generator";
import MoreCarsForYouRevamp from "../more-cars-for-you-revamp";
import { LOGIN_SOURCE } from "../../../au-c2b/constants/app-constants";

// REVAMP
import FeatureSpecification from "../cdp-feature-specification";
import ServiceHistoryRevamp from "../service-history-revamp";
import CarDetailsCardRevamp from "../car-details-card-revamp";
import AboutThisCarRevamp from "../about-this-car-revamp";
import QualityPromiseRevamp from "../quality-promise-revamp";
import LoanCalculatorRevamp from "../loan-calculator-revamp";
import CdPFirstFoldBottomBannerRevamp from "../cdp-first-fold-bottom-banner-revamp/";
import CarDetailNavigationMenuRevamp from "../car-detail-navigation-menu-revamp/component";
import CarDetailStickyViewRevamp from "../car-detail-sticky-view-revamp";
import PremiumFeatureRevamp from "../premium-feature-revamp";
import { SITE_CONTROL_EVENTS } from "../../../tracking/site-control-events";
import CarDetailAtfVariantRevamp from "../car-detail-atf-variant-revamp";
import HappyPurchase from "../happy-purchase/component";
import MoreCarsRevamp from "../more-cars-revamp";
import BuyWithConfidenceRevamp from "../buy-with-confidence-revamp";
import H2 from "../../shared/h2/component";
import { EVENT_CONSTANTS, EVENT_DATA } from "./tracking";
import CdpCarToTradeIn from "../cdp-car-to-trade-in";
import CdpGoToTop from "../cdp-go-to-top/component";
import isTestDriveEnabledState from "../../../utils/helpers/is-test-drive-enabled-state";
import useShowTradeInCheckoutStep from "../../../hooks/use-show-trade-in-checkout-step";

const CarDetailsRevamp = ({
    match: {
        params: { lid: carId }
    },
    carDetails,
    fetchCarDetailsConnect,
    updateCarDetailsSSRStatusConnect,
    setGsGalleryDataConnect,
    history,
    fetchSimilarCarsConnect,
    getDeliveryInfoConnect,
    setOnLoginSuccessCallback,
    openLoginPopupConnect,
    orderStatus,
    isLoggedIn,
    onClickAddToWishList,
    secureToken,
    orderId,
    isWishlistedCar,
    getOrderDetailConnect,
    fetchConfigConnect,
    // showFullScreenGallery = {},
    saleConfig = {},
    updateLoginFetchCarDetailCompletedConnect,
    fetchEgcPriceConnect,
    updateOrderConnect,
    getCheckoutStepsConnect,
    getTradeInToggleVisibleConnect,
    tradeInToggleSelected,
    getWarrantyPlansConnect,
    // showPreApprovalCoachmark,
    setPreApprovalCoachMarkDisplayConnect,
    showUserDeliveryTimeline,
    setDeliveryTimelineConnect,
    financeProvider,
    email,
    allFilters,
    appliedFilters,
    selectedSort,
    listingType,
    isUserZeroDpVariant,
    showCdpGalleryVariant,
    hideSiteHeader = false,
    cdpBiCta,
    testDriveStatus,
    setLoginTypeConnect,
    getIsStraightThroughEligbleConnect,
    getInterestRateForPriceCalculatorConnect,
    userGeoData,
    // showTestDriveLocation
    updateValidC2bOrderConnect,
    getTradeInDetailsConnect,
    drivingLicenceStatus,
    testDriveConfig
}) => {

    const { content, isSSR, isFetching, config, error, ipDetectedState = "", isLoginFetchCarDetailCompleted = false, similarCars, eligibleForExtendedWarranty  } = carDetails;
    const { appointmentId,
        booked,
        year,
        // modelYear,
        make,
        model,
        comingSoon,
        egc = 0,
        kbbAskingPriceRangeMin = 0,
        kbbAskingPriceRangeMax = 0,
        listingActive,
        // emiDetails,
        personalised,
        serviceHistory = [],
        reserved,
        kbbValueProvidedOn,
        kbbAskingPrice,
        city, state,
        similarModelCars = [],
        buyWithConfidence
    } = content || {};
    const cdpBiCtaVariant = showCdpBiCtaVariant(cdpBiCta) || {};
    const showKBB = egc && kbbAskingPriceRangeMin >= 0 && kbbAskingPriceRangeMax && egc < kbbAskingPrice;
    const { state: { name: userState = {}} = {}} = userGeoData || {};
    const [commingSoonModal, setCommingSoonModal] = useState(false);
    const [carReservationModalOpen, setCarReservationModal] = useState(false);
    const [notifyIconCliked, setNotifyIconClicked] = useState(false);
    const [wishlistActionCompleted, setWishlistActionCompleted] = useState(false);
    const [isStickyHeaderVisible, setIsStickyHeaderVisible] = useState(false);
    const [showKbbModal, setShowKbbModal] = useState({detail: false, approach: false});
    const [isResumeVisible, setIsResumeVisible] = useState(false);
    const [isFetchingOrderDetails, setIsFetchingOrderDetails] = useState(false);
    const [step, setStep] = useState(null);
    const {showTradeInCheckoutStep} = useShowTradeInCheckoutStep();
    const calculatorRef = useRef(null);
    // const [isLoading, setLoading] = useState(false);
    // const modelYearName = modelYearNameGenerator(modelYear);
    // const carFullName = `${year || ""} ${make || ""} ${model || ""} ${modelYearName}`;
    const isGalleryView = (useLocation().pathname.indexOf("gallery")) > 0;
    const query = (useLocation().search || "").toString();
    const {data: showCdpGalleryVariantData} = showCdpGalleryVariant || {};

    const { data: showDeliveryTimelineData } = showUserDeliveryTimeline || {};
    const deliveryTimelineVariant = showDeliveryTimelineData === EXPERIMENT_TYPE.VARIANT_B;
    const enableNewPostBook =  (financeProvider === LOAN_PROVIDER.NONE || financeProvider === LOAN_PROVIDER.BYOF) && (drivingLicenceStatus === VERIFY_LICENCE_STATES.UPLOAD_PENDING);
    const filterDimensionsGA4 = parseFilterToDimensionGA4(allFilters, appliedFilters, selectedSort);

    const showS20GalleryVariant = showCdpGalleryVariantData === EXPERIMENT_TYPE.VARIANT_B;
    const {data: testDriveVariant} = "VARIANT_B";
    const {data: customStateVariant} = {};
    const tradeInRef = useRef(null);
    const { eligibleStateNames = [] } = testDriveConfig?.data || {};

    useEffect(() => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_LOCATION_EXPOSURE, {
            eventAction: AU_DESKTOP_EVENTS.TEST_DRIVE_LOCATION_EXPOSURE,
            eventLabel: testDriveVariant,
            eventCategory: "Cars24_detail_page"
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.WEB_CUSTOM_STATE_EXPERIMENT, {
            eventAction: AU_DESKTOP_EVENTS.WEB_CUSTOM_STATE_EXPERIMENT,
            eventLabel: `${customStateVariant}_${JSON.stringify(userGeoData)}`,
            eventCategory: "Cars24_detail_page"
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        // eslint-disable-next-line no-nested-ternary
        const userId = personalised ? "PRE_APPROVED" : isLoggedIn ? "NOT_PRE_APPROVED" : "NOT_LOGGED_IN";
        if (appointmentId && !personalised) {
            const params = {
                appointmentId,
                userId,
                year,
                ...egc >= 0 && {price: +egc},
                creditScore: "EXCELLENT"
            };
            getInterestRateForPriceCalculatorConnect(params);
        }
    }, [appointmentId, personalised, year, getInterestRateForPriceCalculatorConnect, isLoggedIn, egc]);
    useEffect(() => {
        const queryParams = qs.parse(query);
        // eslint-disable-next-line camelcase
        const { referrer_source = "origin", enableMinimumPay } =  queryParams || {};
        saveCookie(REFERRER_SOURCE, referrer_source);
        if ("enableMinimumPay" in queryParams) {
            saveCookie(ENABLE_MINIMUM_SPLIT_PAY, enableMinimumPay, NUMBER.THREE);
        }
        const showTdfViaQuery = (queryParams || {}).tdf === "true";//tdf => testdriveflow
        const testDriveViaFeatureFlag = showFeature(FEATURE_FLAG_KEYS.TEST_DRIVE_FLAG, NUMBER.FIFTY);
        if (showTdfViaQuery) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventAction: "variant_with_test_drive",
                eventLabel: "NA"
            });
        } else  if (!testDriveViaFeatureFlag) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventAction: "variant_without_test_drive",
                eventLabel: "NA"
            });
        } else if (testDriveViaFeatureFlag) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventAction: "variant_with_test_drive",
                eventLabel: "NA"
            });
        }
    }, [query]);

    useEffect(() => {
        if (showCdpGalleryVariantData === EXPERIMENT_TYPE.VARIANT_A) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.S20_VIEWER_AND_GALLERY, {
                eventLabel: "VARIANT_A"
            });
        } else if (showCdpGalleryVariantData === EXPERIMENT_TYPE.VARIANT_B) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.S20_VIEWER_AND_GALLERY, {
                eventLabel: "VARIANT_B"
            });
        }
    }, [showCdpGalleryVariantData]);

    useEffect(() => {
        if (showDeliveryTimelineData === EXPERIMENT_TYPE.VARIANT_A) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CDP_DELIVERY_TIMELINE, {
                eventAction: "cdp_delivery_timeline",
                eventLabel: "VARIANT_A"
            });
        } else if (showDeliveryTimelineData === EXPERIMENT_TYPE.VARIANT_B) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CDP_DELIVERY_TIMELINE, {
                eventAction: "cdp_delivery_timeline",
                eventLabel: "VARIANT_B"
            });
        }
    }, [showDeliveryTimelineData]);

    useEffect(() => {
        if ((saleConfig && saleConfig.data && Object.keys(saleConfig.data).length === 0) || carId !== appointmentId) {
            fetchConfigConnect();
        }
        // clearing the 500 minimum key from storage for every BI
        clearItem(ENABLE_MINIMUM_SPLIT_PAY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchConfigConnect]);

    useEffect(() => {
        // if (isVariant) {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_AB, {eventLabel: "full_view"});
        // } else {
        //     trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_AB, {eventLabel: "normal_view"});
        // }
        if (appointmentId && appointmentId === carId) {
            fetchEgcPriceConnect(appointmentId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId, fetchEgcPriceConnect, tradeInToggleSelected]);

    useEffect(() => {
        if (ipDetectedState) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LOCATION_STATE_DETAIL, {eventLabel: ipDetectedState});

        }
        const userStateValue =  parseCookie(SET_DELIVERY_TIMELINE) || ipDetectedState;
        setDeliveryTimelineConnect(DELIVERY_TIMELINE_MAPPING[userStateValue] || {});
    }, [ipDetectedState, setDeliveryTimelineConnect]);

    useEffect(() => {
        if ((appointmentId === carId) && !isGalleryView) {
            const data = carListingEventDataParser(content, {
                list: CAR_LIST_EVENT_NAMES.DETAILS,
                excludedKeys: [
                    "list"
                ]
            });
            const dataGA4 = carListingEventDataParserGA4(content, {
                filterDimensions: filterDimensionsGA4,
                listingType
            });
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS, data.carDetails);
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_LOCATION, {eventLabel: `${appointmentId}_${city}`});
            trackDesktopCustomEventsAU("clearEccomerce", { ecommerce: null });
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.VIEW_ITEM, {
                user_id: email,
                ...dataGA4
            });

            // Amplitude Events

            //cleverTap
            const detailsData = clevertapDetails(content, {prefix: "viewed_", config});
            desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.CAR_DETAIL_PAGE_VIEWED, detailsData);

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId, isGalleryView]);

    useEffect(() => {
        if (appointmentId) {
            if (isGalleryView) {
                const queryParams = qs.parse(query);
                const { selectedImageIndex = 0, activeTab = "exterior" } = queryParams;
                setGsGalleryDataConnect({
                    isOpen: true,
                    activeTab,
                    selectedImageIndex: parseInt(selectedImageIndex)
                });
            } else {
                setGsGalleryDataConnect({
                    isOpen: false
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isGalleryView, appointmentId]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [carId, setGsGalleryDataConnect]);

    useEffect(() => {
        if (isLoggedIn) {
            getTradeInToggleVisibleConnect();
            getIsStraightThroughEligbleConnect();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if (isLoggedIn && (!isLoginFetchCarDetailCompleted || (appointmentId !== carId)) || tradeInToggleSelected) {
            fetchCarDetailsConnect(carId, {showS20GalleryVariant}).then(({detail}) => {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.CAR_DETAIL, {ecomm_prodid: detail.appointmentId, ecomm_totalvalue: detail.egc });
            });
            updateLoginFetchCarDetailCompletedConnect(true);
        }
        if (carId && ((similarCars || []).length === 0) || (appointmentId !== carId || tradeInToggleSelected)) {
            fetchSimilarCarsConnect(carId, { size: 10, userFinanceType: FINANCE_TYPE.CARS24});
        }
        if (isLoggedIn) {
            getWarrantyPlansConnect(`?appointmentId=${carId}`);
        }
        return (() => {
            updateLoginFetchCarDetailCompletedConnect(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, tradeInToggleSelected]);

    useEffect(() => {
        if (!isSSR && appointmentId !== carId) {
            fetchCarDetailsConnect(carId, {showS20GalleryVariant}).then(({detail}) => {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.CAR_DETAIL, {ecomm_prodid: detail.appointmentId, ecomm_totalvalue: detail.egc });
            });
        } else {
            updateCarDetailsSSRStatusConnect(false);
        }
        addToRecentlyViewed(AU_RECENTLY_VIEWD_KEY, carId);
        // if (carId) {  fetchSimilarCarsConnect(carId, { size: 20 }); }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carId]);

    useEffect(() => {
        if (!isLoggedIn) {
            getWarrantyPlansConnect(null, carId, NOT_LOGGED_IN);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if (secureToken) {
            getTradeInDetailsConnect({fromCdp: true});
        }
    }, [getTradeInDetailsConnect, secureToken]);

    // this GA event was part of the test drive location which is not going to be live.
    // React.useEffect(() => {
    //     const testDriveLocationVariant = ((showTestDriveLocation || {}).data || "").toLowerCase().replace("_", " ");
    //     trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TESTDRIVE_CDP_LOCATION, {
    //         event: "custom_event",
    //         eventAction: testDriveLocationVariant,
    //         eventCategory: "testdrive_cdp_location",
    //         eventLabel: "NA"
    //     });

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    const getOrder = useCallback(async () => {
        try {
            setIsFetchingOrderDetails(true);
            const response = await getOrderDetailConnect(carId);
            const stepResponse = await getCheckoutStepsConnect(response.orderId);
            setStep(stepResponse);
            if (stepResponse.step && stepResponse.nextStep) {
                setIsResumeVisible(true);
            }
        } catch (err) {
            // createOrderConnect()
        } finally {
            setIsFetchingOrderDetails(false);
        }
        // eslint-disable-next-line
    }, [carId, appointmentId]);

    useEffect(() => {
        if (carId && secureToken && !carDetails.isFetching && carId === appointmentId) {
            getOrder();

        }
        // eslint-disable-next-line
    }, [carId, appointmentId, secureToken]);

    useEffect(() => {
        if (personalised) {
            window.setTimeout(() =>
                setPreApprovalCoachMarkDisplayConnect(false),
            NUMBER.FIVE_THOUSAND
            );
        }
    }, [personalised, setPreApprovalCoachMarkDisplayConnect]);

    const wishlistSuccessCallback = (shortListed, showNotifyPopup) => {
        if (shortListed && showNotifyPopup) {
            setNotifyIconClicked(false);
            setWishlistActionCompleted(true);
            setCarReservationModal(true);
        }
    };

    const ecommerEventData = () => {
        const data = carListingEventDataParser(content, {
            list: CAR_LIST_EVENT_NAMES.DETAILS
        });
        return data;
    };

    const addItemToWishlist = (token, additionalProps = {}, gtmFrom = "") => {
        // const { access_token: token } = resp;
        const {addtoWishList} = ecommerEventData();
        trackDesktopCustomEventsAU(FB_EVENTS_CATEGORY.CDP_ADD_TO_WISHLIST, {content: addtoWishList});
        onClickAddToWishList(carId, token || secureToken, gtmFrom || "car_detail_page", { ...additionalProps, comingSoon, make, model, callback: wishlistSuccessCallback });
    };

    const onWishlistClick = (e, gtmFrom, showNotifyPopup = false) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (isLoggedIn) {
            addItemToWishlist("", {showNotifyPopup}, gtmFrom);
        } else {
            setLoginTypeConnect(LOGIN_TYPE.WISHLIST);
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LOGIN_INITIATED, {eventLabel: LOGIN_SOURCE.WISHLIST});
            setOnLoginSuccessCallback((resp) => {
                const { access_token: token } = resp.profileResponse || resp;
                addItemToWishlist(token, {showNotifyPopup}, gtmFrom);
            });
            openLoginPopupConnect();
        }
    };

    const trackEvent = (type, label, ctaSource = null) => {
        switch (type) {
        case AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS:
            label = "selected get_started";
            trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.BOOKING_INITIATED, {
                ecomm_prodid: appointmentId,
                ecomm_totalvalue: egc
            });
            break;
        case AU_DESKTOP_EVENTS.CAR_DETAILS_PRICE_BREAK_DOWN_GET_STARTED:
            break;
        case AU_DESKTOP_EVENTS.START_PURCHASE:
            break;
        case AU_DESKTOP_EVENTS.CAR_GALLERY_VIEW:
            break;
        case AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_GET_STARTED:
            label = ctaSource;
            break;
        case AU_DESKTOP_EVENTS.BUY_ONLINE_CTA_CLICKED:
            break;
        default: type = "";
        }
        if (type) {trackDesktopCustomEventsAU(type, {eventLabel: label});}
    };

    const updateOrderForBuyNow = (data, e, ctaSource = null) => {
        const payload = {
            orderType: ORDER_TYPE.BUY_ONLINE
        };
        if (ctaSource) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventLabel: ctaSource
            });
        } else {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventAction: "cta_selected",
                eventLabel: "buy_online"
            });
        }
        if (orderId) {
            updateOrderConnect(orderId, payload).then(() => {
                const { relativeURL } = getCheckoutPageURL(content, checkoutRoutes.basicDetails.route);
                history.push(relativeURL);
            });
        } else {
            const { relativeURL } = getCheckoutPageURL(content, checkoutRoutes.basicDetails.route);
            history.push(relativeURL);
        }
        updateValidC2bOrderConnect(secureToken);
    };

    const onGetStartedClick = (event, e, ctaSource = null) => {
        trackEvent(event, "selected get_started", ctaSource);
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.ZERO_DP_CDP, {
            eventLabel: isUserZeroDpVariant ? "Clicked_Variant B" : "Clicked_Variant A"
        });
        if (isLoggedIn) {
            updateOrderForBuyNow();
        } else {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {eventAction: "sign_up", eventLabel: "sign_up_screen_shown"});
            const { relativeURL } = getCheckoutPageURL(content, checkoutRoutes.basicDetails.route);
            history.push(relativeURL);
        }

        trackDesktopCustomEventsAU(EVENT_CONSTANTS.CHECKOUT_INITIATED, EVENT_DATA.CHECKOUT_INITIATED);
    };
    const rioProps = {
        threshold: 0,
        rootMargin: "-144px 0px 0px 0px"
    };

    const isPreviousSectionInView = (arr, index) => {
        for (let i = 0; i < index; i++) {
            if (arr[i].inView) {
                return true;
            }
        }
        return false;
    };
    const [premiumFeaturesRef, premiumFeaturesRefInView, premiumFeaturesEntry] = useInView(rioProps);
    const [featuresAndSpecsRef, featuresAndSpecsRefInView, featuresAndSpecsRefEntry] = useInView(rioProps);
    const [qualityPromiseRef, qualityPromiseRefInView, qualityPromiseRefEntry] = useInView(rioProps);
    const [carhistoryRef, carhistoryRefInView, carhistoryRefEntry] = useInView(rioProps);
    const [loanCalculatorRef, loanCalculatorRefInView, loanCalculatorRefEntry] = useInView(rioProps);
    // const [faqRef, faqRefInView, faqRefEntry] = useInView(rioProps);

    const menuItems = [
        { label: "Premium Features", inView: premiumFeaturesRefInView, entry: premiumFeaturesEntry, gtmLabel: "premium_features", isVisible: true},
        { label: "Feature and Specifications", inView: featuresAndSpecsRefInView, entry: featuresAndSpecsRefEntry, gtmLabel: "feature_and_specifications", isVisible: true},
        { label: "Car History", inView: carhistoryRefInView, entry: carhistoryRefEntry, gtmLabel: "car_history", isVisible: true},
        { label: "Car imperfections", inView: qualityPromiseRefInView, entry: qualityPromiseRefEntry, gtmLabel: "quality_promise", isVisible: true},
        { label: "Loan Calculator", inView: loanCalculatorRefInView, entry: loanCalculatorRefEntry, gtmLabel: "loan_calculator", isVisible: true}
        // { label: "FAQs", inView: faqRefInView, entry: faqRefEntry, gtmLabel: "buy_with_cars24", isVisible: true}
    ].filter(Boolean)
        .map((item, index, arr) => {
            return {
                ...item,
                inView: isPreviousSectionInView(arr, index) ? false : item.inView
            };
        });

    const onChangeInView = (inView) => {
        const isVisible = !inView && premiumFeaturesRefInView;
        // eslint-disable-next-line no-magic-numbers
        setIsStickyHeaderVisible(isVisible ? isVisible && window.scrollY > 600 : isVisible);
    };

    const onTop = () => {
        setIsStickyHeaderVisible(false);
    };

    const handleCommingSoonModal = () => {
        setCommingSoonModal(!commingSoonModal);
        // setLoading(false);
    };

    const getNotify = () => {
        // setLoading(true);
        const carStatus = {comingSoon, make, model};
        if (isLoggedIn) {
            addItemToWishlist(null, {callback: handleCommingSoonModal, carStatus});
        } else {
            openLoginPopupConnect();
            setOnLoginSuccessCallback((resp) => {
                const { access_token: token } = resp;
                addItemToWishlist(token, {callback: handleCommingSoonModal,  carStatus});
            });
        }
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.COMING_SOON_NOTIFY_ME);
    };

    const handleCarReservationModal = () => {
        setCarReservationModal(!carReservationModalOpen);
        if (!carReservationModalOpen) {
            setWishlistActionCompleted(false);
            setNotifyIconClicked(false);
        }
    };

    const onClickNotifyIcon = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME_TOOLTIP);
        setNotifyIconClicked(true);
        setCarReservationModal(true);
    };

    const onResumeRedirect = () => {
        if (isLoggedIn) {

            let routeStep = "";
            if (step.nextStep === CHECKOUT_STEPS.TRADEIN && !showTradeInCheckoutStep) {
                routeStep = (!eligibleForExtendedWarranty) ? CHECKOUT_STEPS.ADDONS : CHECKOUT_STEPS.CARCOVER;
            } else {
                routeStep = step.nextStep;
            }
            const {relativeURL} = getCheckoutPageURL({make, model, appointmentId}, checkoutRoutes[CHECKOUT_STEPS_PATH[routeStep]].route);
            updateValidC2bOrderConnect(secureToken);
            history.push(relativeURL);
        } else {
            openLoginPopupConnect();
            setOnLoginSuccessCallback(() => {
                const {relativeURL} = getCheckoutPageURL({make, model, appointmentId}, checkoutRoutes[CHECKOUT_STEPS_PATH[step.nextStep]].route);
                history.push(relativeURL);
            });
        }
    };

    const getCta = () => {
        let {text = "GET STARTED"} = cdpBiCtaVariant;
        let action = onGetStartedClick;
        let disabled = false;
        let iconType = "Wishlist";
        let transparentButton = false;
        let key = "";
        if (isResumeVisible && isLoggedIn) {
            text = "CONTINUE BUYING";
            action = onResumeRedirect;
            disabled = false;
        }
        if (isTestDriveEnabledState({state, userState, eligibleStateNames})) {
            text = "BUY ONLINE";
        }
        if (postOrderBookingConfirmed(orderStatus)) {
            text = "TRACK ORDER";
            disabled = false;
            action = (data, e, ctaSource = null) => {
                const { relativeURL: viewTaskUrl } = getMyBookingCarDetailsURL(
                    content.appointmentId,
                    enableNewPostBook ? postPaymentRoutes.addOns.route : tasksRoutes.addOns.route,
                    null,
                    enableNewPostBook ? EXPERIMENT_TYPE.VARIANT_B : null
                );
                if (ctaSource) {
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_TRACK_ORDER, {
                        eventLabel: ctaSource
                    });
                }
                history.push(viewTaskUrl);
            };
        } else if (booked || !listingActive) {
            text = "SOLD";
            disabled = true;
            action = () => {};
        } else if (reserved) {
            if (orderStatus === ORDER_STATUS.TEST_DRIVE_RESERVED) {
                text = "BUY NOW";
                disabled = false;
                iconType = null;
                action =  updateOrderForBuyNow;
            } else if (isWishlistedCar(carId)) {
                text = "REMOVE FROM WISHLIST";
                disabled = false;
                iconType = null;
                key = "removedReservationNofication";
                action = (data, e, ctaSource = null) => {
                    handleCarReservationModal();
                    if (ctaSource) {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_REMOVE_FROM_WISHLIST, {
                            eventLabel: ctaSource
                        });
                    } else {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_REMOVE_FROM_WISHLIST, {
                            eventLabel: "reserved"
                        });
                    }
                };
                transparentButton = true;
            } else {
                text = "NOTIFY IF AVAILABLE";
                disabled = false;
                iconType = "Info";
                key = "addReservationNotification";
                action = (data, e, ctaSource = null) => {
                    const showNotifyPopup = true;
                    onWishlistClick(e, "", showNotifyPopup);
                    if (ctaSource) {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_NOTIFY_IF_AVAILABLE, {
                            eventLabel: ctaSource
                        });
                    } else {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME_CTA);
                    }
                    const detailsData = clevertapDetails(content, {prefix: "notify_", config});
                    desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.NOTIFY_ME, detailsData);
                    // handleCarReservationModal();
                };
            }
        } else if (comingSoon) {
            text =  "Notify Me";
            disabled = isWishlistedCar(carId) ? true : false;
            iconType = null;
            action = getNotify;
            key = "comingSoon";
        }
        if (testDriveStatus === ORDER_STATUS.TEST_DRIVE_COMPLETED) {
            text = "CONTINUE BUYING";
        }
        return { text, action, disabled, iconType, transparentButton, key };
    };

    const handleKbbModal = (type, value) => {
        setShowKbbModal({...showKbbModal, [type]: value});
    };

    const closeModal = (type, value) => {
        showSiteControlWidget(SITE_CONTROL_EVENTS.SHOW_ON_KBB_CLOSE);
        handleKbbModal(type, value);
    };
    const cta = getCta();
    // const isSaleOn = true;

    const scrollToSection = (ref) => {
        if (ref) {
            trackDesktopCustomEventsAU(EVENT_CONSTANTS.LOAN_CALCULATOR_CDP_ACTION, EVENT_DATA.LOAN_CALCULATOR_CDP_ACTION);

            // eslint-disable-next-line no-unused-expressions
            ref.current && ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    const onTradeInBannerClick = () => {
        if (tradeInRef) {tradeInRef.current.scrollIntoView({ behavior: "smooth", block: "center" });}
        trackDesktopCustomEventsAU(EVENT_CONSTANTS.TRADE_IN_BANNER_ACTION, EVENT_DATA.TRADE_IN_BANNER_ACTION);
    };

    // eslint-disable-next-line no-nested-ternary
    return !isFetching && content && !error ? (
        <React.Fragment>
            <MetaTagsCarDetailsV2 config={config} carDetails={content} cityName={COUNTRY.name} countryCode="au" />
            <div styleName={`styles.${isStickyHeaderVisible ? "visible" : "hidden"}`}>
                <CarDetailStickyViewRevamp
                    isWishlisted={isWishlistedCar(carId)}
                    onWishlistClick={onWishlistClick}
                    onClickNotifyIcon={onClickNotifyIcon}
                    ctaProps={cta}
                    comingSoon={comingSoon}
                />
                <CarDetailNavigationMenuRevamp menuItems={menuItems} />
            </div>
            <InView rootMargin={"150px 0px 150px 0px"} as="div" onChange={onTop} />
            <div className="container">
                <CarDetailAtfVariantRevamp
                    onWishlistClick={onWishlistClick}
                    isWishlisted={isWishlistedCar(carId)}
                    ctaProps={cta}
                    comingSoon={comingSoon}
                    handleKbbModal={handleKbbModal}
                    // isSaleOn={isSaleOn}
                    isFetchingOrderDetails={isFetchingOrderDetails}
                    isKbbShown={!!showKBB}
                    onClickNotifyIcon={onClickNotifyIcon}
                />
            </div>
            <div className="container" styleName={"styles.aboutThisCarTitle"}>
                <H2 text="About this car" />
                <div styleName={"styles.aboutThisCarWrapper"}>
                    <AboutThisCarRevamp
                    // serviceHistoryRef={serviceHistoryRef}
                    // carDetailsRef={carDetailsRef}
                        showDeliveryTimeLine={deliveryTimelineVariant}
                        getDeliveryInfoConnect={getDeliveryInfoConnect}
                        setDeliveryTimelineConnect={setDeliveryTimelineConnect}
                    />
                    <CarDetailsCardRevamp
                        content={content}
                        ctaProps={cta}
                        onWishlistClick={onWishlistClick}
                        isWishlisted={isWishlistedCar(carId)}
                        comingSoon={comingSoon}
                        onClickNotifyIcon={onClickNotifyIcon}
                        isFetchingOrderDetails={isFetchingOrderDetails}
                        calculatorRef={calculatorRef}
                        scrollToSection={scrollToSection}
                    />
                </div>

            </div>
            <InView rootMargin={"-150px 0px 0px 0px"} as="div" onChange={onChangeInView} />
            <TrackImpression event={{
                amplitudeName: EVENT_CONSTANTS.CARD_VIEWED,
                properties: {
                    "Card_viewed": "Finance_CDP"
                },
                gaName: EVENT_CONSTANTS.CARD_VIEWED,
                data: EVENT_DATA.CARD_VIEWED
            }}>
                <CdPFirstFoldBottomBannerRevamp onTradeInBannerClick={onTradeInBannerClick}/>
            </TrackImpression>
            <div className="container" ref={premiumFeaturesRef}>
                <TrackImpression event={{amplitudeName: CDP_REVAMP_AMPLITUDE_EVENTS.PREMIUM_FEATURES_SECTION_SEEN}}>
                    <PremiumFeatureRevamp />
                </TrackImpression>
            </div>
            <div className="container" ref={featuresAndSpecsRef}>
                <TrackImpression event={{amplitudeName: CDP_REVAMP_AMPLITUDE_EVENTS.FNS_SECTION_SEEN}}>
                    <FeatureSpecification />
                </TrackImpression>
            </div>
            <TrackImpression event={{amplitudeName: CDP_REVAMP_AMPLITUDE_EVENTS.VALUE_PROPS_SEEN}}>
                <div className="container" >
                    {(buyWithConfidence || []).length ? <BuyWithConfidenceRevamp fullWidth={true} source={PAGE_SOURCE.CDP.toUpperCase()} showHeader={false} buyWithConfidence={buyWithConfidence || []} config={config} /> : null}
                </div>
            </TrackImpression>
            <div className="container" ref={carhistoryRef}>
                <TrackImpression event={{amplitudeName: CDP_REVAMP_AMPLITUDE_EVENTS.SERVICE_HISTORY_SECTION_SEEN}}>
                    <ServiceHistoryRevamp config={config} content={content}  serviceHistory={serviceHistory}/>
                </TrackImpression>
            </div>
            <div className="container" ref={qualityPromiseRef}>
                <TrackImpression event={{amplitudeName: EVENT_CONSTANTS.IMPERFECTION_SEEN}}>
                    <QualityPromiseRevamp />
                </TrackImpression>
            </div>
            <div className="container" ref={loanCalculatorRef}>
                <TrackImpression event={{amplitudeName: EVENT_CONSTANTS.CALCULATOR_SECTION_SEEN}}>
                    <LoanCalculatorRevamp calculatorRef={calculatorRef} ctaProps={cta}  />
                </TrackImpression>
            </div>
            <div className="container" styleName={"styles.testimonialWrapper"}>
                <TrackImpression event={ {amplitudeName: AMPLITUDE_EVENTS_CATEGORY.HAPPY_PURCHASES_SEEN}} wrapWithDiv = {false}>
                    <HappyPurchase showTitle={false} source={PAGE_SOURCE.CDP} />
                </TrackImpression>
            </div>

            {(similarCars || []).length ? <div className="container">
                <TrackImpression event={ {amplitudeName: CDP_REVAMP_AMPLITUDE_EVENTS.SIMILAR_CARS_ON_CDP_SEEN}} wrapWithDiv = {false}>
                    <MoreCarsRevamp isCdpRevamp={true} config={config} carList={similarCars} title={"Similar cars for you"} isMoreCars={true} />
                </TrackImpression>
            </div> : null}

            {similarModelCars.length ? <div className="container">
                <TrackImpression event={ {amplitudeName: AMPLITUDE_EVENTS_CATEGORY.MORE_MODELS_FOR_YOU_SEEN}} wrapWithDiv = {false}>
                    <MoreCarsRevamp isCdpRevamp={true} config={config} carList={similarModelCars || []} title={`More ${`${make  } ${model}`} cars for you`} isMoreCars={false}/>
                </TrackImpression>
            </div> : null}

            <TrackImpression event={{name: "moreCarsForYouViewed", data: {"platform": WEB_SOURCE.desktop}}}>
                <div className="container">
                    <MoreCarsForYouRevamp isCdpRevamp = {true}/>
                </div>
            </TrackImpression>
            <div ref={tradeInRef} className="container">
                <CdpCarToTradeIn />
            </div>
            <TrackImpression event={{name: "faqViewd"}}>
                <CarDetailsFaq faqCdpRevamp={true}
                // faqRef={faqRef}
                />
            </TrackImpression>
            {!hideSiteHeader && <ErrorHandler>
                <CDPBreadCrumb />
            </ErrorHandler>
            }
            {/* {commingSoonModal && <CommingSoonThankModal onClose={handleCommingSoonModal} title={carFullName}/> } */}
            {showKbbModal.detail &&
                <KelleyBlueBookPopup
                    onClose={() => closeModal("detail", false)}
                    carEgcPrice={egc}
                    kbbAskingPriceRangeMin={kbbAskingPriceRangeMin}
                    kbbAskingPriceRangeMax={kbbAskingPriceRangeMax}
                    kbbValueProvidedOn={kbbValueProvidedOn}
                /> }
            {/* {showKbbModal.approach &&
                <CarPricingApproachPopup
                    onClose={() => closeModal("approach", false)}
                /> } */}
            {
                carReservationModalOpen &&
                    <CarReservationNotifyModal
                        isOpen={carReservationModalOpen}
                        notifyIconCliked={notifyIconCliked}
                        onClickNotifyIcon={onClickNotifyIcon}
                        cta={cta}
                        reserved={reserved}
                        isWishlistedCar={isWishlistedCar(carId)}
                        onWishlistClick={onWishlistClick}
                        wishlistActionCompleted={wishlistActionCompleted}
                        handleCarReservationModal={handleCarReservationModal}
                    />
            }
            {/* {showPreApprovalCoachmark &&  <CoachMark showCoachMark={showPreApprovalCoachmark}/>} */}
            <div styleName={"styles.goToTopContainer"}>
                <CdpGoToTop />
            </div>
        </React.Fragment>
    ) : (
        error ? <PageNotFoundRevamp /> : <Skeleton />
    );
};

CarDetailsRevamp.propTypes = {
    match: PropTypes.object,
    carDetails: PropTypes.object,
    fetchCarDetailsConnect: PropTypes.func,
    updateCarDetailsSSRStatusConnect: PropTypes.func,
    setGsGalleryDataConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func,
    fetchSimilarCarsConnect: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    getDeliveryInfoConnect: PropTypes.func,
    setOnLoginSuccessCallback: PropTypes.func,
    openLoginPopupConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    history: PropTypes.object,
    selectedCity: PropTypes.object,
    similarCars: PropTypes.object,
    orderStatus: PropTypes.string,
    onClickAddToWishList: PropTypes.func,
    secureToken: PropTypes.string,
    appliedDeliveryPincode: PropTypes.number,
    isWishlistedCar: PropTypes.func,
    getOrderDetailConnect: PropTypes.func,
    updateLoginFetchCarDetailCompletedConnect: PropTypes.func,
    splitPaymentOpted: PropTypes.bool,
    showFullScreenGallery: PropTypes.bool,
    isUserZeroDpVariant: PropTypes.bool,
    fetchConfigConnect: PropTypes.func,
    saleConfig: PropTypes.func,
    fetchEgcPriceConnect: PropTypes.func,
    updateOrderConnect: PropTypes.func,
    orderId: PropTypes.string,
    getCheckoutStepsConnect: PropTypes.func,
    getInhouseEligibilityConnect: PropTypes.func,
    showInHouseFinance: PropTypes.string,
    inHouseFinanceEligibility: PropTypes.bool,
    getTradeInToggleVisibleConnect: PropTypes.func,
    tradeInToggleSelected: PropTypes.bool,
    getWarrantyPlansConnect: PropTypes.func,
    showPreApprovalCoachmark: PropTypes.bool,
    setPreApprovalCoachMarkDisplayConnect: PropTypes.func,
    showPremiumFeatures: PropTypes.object,
    setDeliveryTimelineConnect: PropTypes.func,
    showUserDeliveryTimeline: PropTypes.object,
    financeProvider: PropTypes.string,
    email: PropTypes.string,
    appliedFilters: PropTypes.object,
    allFilters: PropTypes.object,
    selectedSort: PropTypes.object,
    listingType: PropTypes.string,
    getZeroDpConfigConnect: PropTypes.func,
    showCdpGalleryVariant: PropTypes.object,
    hideSiteHeader: PropTypes.bool,
    cdpBiCta: PropTypes.object,
    testDriveStatus: PropTypes.bool,
    setLoginTypeConnect: PropTypes.func,
    getInhousePreApprovalLoanDetailsConnect: PropTypes.func,
    getIsStraightThroughEligbleConnect: PropTypes.func,
    buyWithConfidence: PropTypes.func,
    getInterestRateForPriceCalculatorConnect: PropTypes.func,
    userGeoData: PropTypes.object,
    updateValidC2bOrderConnect: PropTypes.func,
    gaId: PropTypes.string,
    showEmailSupportModal: PropTypes.bool,
    getTradeInDetailsConnect: PropTypes.func,
    drivingLicenceStatus: PropTypes.bool,
    testDriveConfig: PropTypes.object
};

export default CarDetailsRevamp;
